// Module
var code = "<div class=\"{{class}}\" id=\"{{id}}\"> <script src=\"https://connect.facebook.net/en_US/all.js\" async defer=\"defer\"></script> </div>";
// Exports
module.exports = code;